import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import CookieConsent from 'react-cookie-consent';
import ReactPiwik from 'react-piwik';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import PrintComponent from 'components/PrintComponent';

import { SearchProvider } from 'hooks/useSearch';

import ScrollToTop from 'routers/ScrollToTop';
import SubRouter from 'routers/SubRouter';

import BookingFormView from 'views/BookingFormView';
import LoginView from 'views/LoginView';
import MagicLinkView from 'views/MagicLinkView';
import NotFoundView from 'views/NotFoundView';
// import PreLoginView from 'views/PreLoginView';
import ThankYouView from 'views/ThankYouView';
import WelcomeView from 'views/WelcomeView';

import { demo, piwikSiteid } from 'settings';

const hashLinkScroll = () => {
  const { hash } = window.location;
  if (hash !== '') {
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
};

/**
 * Function to check if cookie a given cookie exists
 *
 * @param {string} cookieName A string containing the name of the cookie to check
 * @returns {boolean} True if cookie exists, false if not
 */
const cookieExists = (cookieName) => {
  const decodedCookies = decodeURIComponent(document.cookie);
  const splitCookies = decodedCookies.split(';');
  return splitCookies.includes(cookieName);
};

export default class AppRouter extends Component {
  constructor(props) {
    super(props);

    // removing the piwik crashes the app. Hence the eslint-disable-next-line
    // eslint-disable-next-line no-unused-vars
    const piwik = new ReactPiwik({
      url: '//data.travpromobile.com/matomo/',
      siteId: piwikSiteid,
      trackErrors: true,
    });
    ReactPiwik.push(['requireConsent']);
    ReactPiwik.push(['trackPageView']);

    this.state = {
      cookies: '',
    };

    this.CookieDecline = this.CookieDecline.bind(this);
    this.CookieAccept = this.CookieAccept.bind(this);
    this.showCookieBar = this.showCookieBar.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (cookieExists('cookieConsent=true') || cookieExists(' cookieConsent=true')) {
      this.setState({ cookies: 'accepted' });
      ReactPiwik.push(['rememberConsentGiven']);
    } else if (cookieExists('cookieConsent=false') || cookieExists(' cookieConsent=false')) {
      ReactPiwik.push(['forgetConsentGiven']);
    } else {
      this.showCookieBar();
    }
  }

  showCookieBar() {
    this.setState({ cookies: 'requiresConsent' });
  }

  CookieAccept() {
    this.setState({ cookies: 'accepted' });
    ReactPiwik.push(['rememberConsentGiven']);
    window.location.reload();
  }

  CookieDecline() {
    this.setState({ cookies: 'declined' });
    ReactPiwik.push(['forgetConsentGiven']);
    document.cookie = 'cookieConsent=false';
    window.location.reload();
  }

  render() {
    const { cookies } = this.state;

    return (
      <BrowserRouter
        onUpdate={(e) => {
          hashLinkScroll(e);
        }}
        history={() => this.piwik.connectToHistory(History)}
      >
        {/* FIXME: Look into alternative. Currently wrapping defining searchProvider within BrowserRouter to allow for HashLinks within the results, but would prefer using contextprovider wrappers inside <App /> */}
        <SearchProvider>
          <ScrollToTop>
            <div className="container">
              <Switch>
                <Route path="/rewards" exact component={BookingFormView} />
                <Route path="/rewards/thank-you" exact component={ThankYouView} />
                <Route path="/" exact render={() => <Redirect to="/login" />} />
                <Route path="/main" render={() => <SubRouter />} />
                <Route
                  path="/print/:firstName/:lastName/:appId"
                  render={(props) => {
                    const { firstName, lastName, appId } = props.match.params;
                    return <PrintComponent firstName={firstName} lastName={lastName} appId={appId} />;
                  }}
                />
                <Route path="/welcome" exact render={() => <WelcomeView />} />
                <Route path="/login" render={(props) => <LoginView key={props.match.path} match={props.match} />} />
                <Route
                  path="/register"
                  exact
                  render={(props) => <LoginView key={props.match.path} match={props.match} keepUserStorage />}
                />
                <Route path="/register-mobile" exact render={(props) => <LoginView match={props.match} />} />

                <Route path="/magic-link" render={(props) => <MagicLinkView match={props.match} />} />
                <Route
                  path="/quick-register"
                  exact
                  render={(props) => <LoginView match={props.match} keepUserStorage />}
                />

                <Route path="/forgot" exact render={(props) => <LoginView match={props.match} />} />
                <Route path="/logout" render={(props) => <LoginView match={props.match} />} />
                <Route component={NotFoundView} />
              </Switch>
              {cookies === 'requiresConsent' && (
                <CookieConsent
                  location="top"
                  onAccept={this.CookieAccept}
                  buttonText={i18n.translate('cookies.consent')}
                  cookieName="cookieConsent"
                  expires={365}
                  containerClasses="cookieConsent"
                  contentClasses="cookieContent"
                  buttonClasses="cookieBtn"
                  debug
                  disableStyles
                >
                  <p className="cookieText">
                    <span>
                      <FontAwesomeIcon icon={['fas', 'shield-alt']} />
                    </span>
                    {i18n.translate('cookies.message')}
                  </p>
                  <button type="button" onClick={this.CookieDecline} className="cookieOptOut btnInverse">
                    {i18n.translate('cookies.optout')}
                  </button>
                </CookieConsent>
              )}
              {demo && (
                <CookieConsent
                  location="bottom"
                  buttonText={i18n.translate('demo.consent')}
                  cookieName="demoConsent"
                  expires={365}
                  containerClasses="demoConsent"
                  contentClasses="cookieContent"
                  buttonClasses="demoBtn"
                  debug
                  disableStyles
                >
                  <p className="cookieText">
                    <span>
                      <FontAwesomeIcon icon={['fas', 'bug']} />
                    </span>
                    {i18n.translate('demo.message')}
                  </p>
                </CookieConsent>
              )}
            </div>
          </ScrollToTop>
        </SearchProvider>
      </BrowserRouter>
    );
  }
}

AppRouter.propTypes = {
  // match: PropTypes.shape(),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

AppRouter.defaultProps = {
  // match: {},
  location: {},
};
